"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDateRange = exports.validateDateTime = exports.validateTime = exports.validateDate = exports.checkFormat = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dateTimeFormat_1 = require("../dateTimeFormat");
const common_1 = require("./common");
const format_1 = require("./format");
const checkFormat = (value, format) => {
    const date = (0, moment_1.default)(value, format);
    const isValid = date.format(format) === value;
    return isValid;
};
exports.checkFormat = checkFormat;
/**
 * ToDo: Need to fix. Wrong implementation
 * getRestrictionDate('2222-11-25', false) => 2222-11-25T00:00:00+06:00
 * moment('2222-11-25', DATETIME_OUTPUT_FORMAT).isValid() => true
 */
const getRestrictionDate = (value, withTime) => {
    if (!value)
        return undefined;
    const dateTime = (0, moment_1.default)(value, dateTimeFormat_1.DATETIME_OUTPUT_FORMAT);
    if (dateTime.isValid())
        return dateTime;
    if (withTime)
        return undefined;
    const date = (0, moment_1.default)(value, dateTimeFormat_1.DATE_OUTPUT_FORMAT);
    if (date.isValid())
        return date;
    return undefined;
};
const getError = (arr, withTime, hasError) => {
    for (const text of arr) {
        const item = getRestrictionDate(text, withTime);
        const isError = item && hasError(item);
        if (isError)
            return item;
    }
    return undefined;
};
const validateDate = (rawDate, restrictions, canCast) => {
    var _a, _b;
    if (!rawDate)
        return undefined;
    const dateText = canCast ? (0, format_1.standardizeInputDate)(rawDate) : rawDate;
    const isValid = (0, exports.checkFormat)(dateText, dateTimeFormat_1.DATE_FORMAT);
    if (!isValid) {
        return [(react_1.default.createElement(react_intl_1.FormattedMessage, { key: 'dateError', id: 'components/Form/Field/Date:invalidDateFormat', defaultMessage: 'The date must be in the format {dateFormat}', values: {
                    dateFormat: dateTimeFormat_1.DATE_FORMAT,
                } }))];
    }
    const today = (0, moment_1.default)().format(dateTimeFormat_1.DATETIME_OUTPUT_FORMAT);
    const tomorrow = (0, moment_1.default)().add(1, 'day').format(dateTimeFormat_1.DATETIME_OUTPUT_FORMAT);
    const date = (0, moment_1.default)(dateText, dateTimeFormat_1.DATE_FORMAT);
    const { disableFutureDays, disabledAfterDay, disablePastDays, disabledBeforeDay, notAllowedBeforeDate, notAllowedAfterDate, allowedDays, } = restrictions || {};
    const getAllowedDays = () => {
        if (!allowedDays)
            return undefined;
        if (Array.isArray(allowedDays))
            return allowedDays;
        return [allowedDays];
    };
    if ((_a = getAllowedDays()) === null || _a === void 0 ? void 0 : _a.some(x => x && (0, moment_1.default)(x).isSame(date, 'day')))
        return undefined;
    const pastDates = [
        disablePastDays ? today : undefined,
        disabledBeforeDay,
        notAllowedBeforeDate,
    ];
    const getPastError = () => {
        var _a;
        if (date.year() < common_1.defaultPastYear)
            return common_1.defaultPastYear;
        return (_a = getError(pastDates, false, (x) => date.isBefore(x, 'day'))) === null || _a === void 0 ? void 0 : _a.format(dateTimeFormat_1.DATE_FORMAT);
    };
    const pastError = getPastError();
    if (pastError) {
        return [(react_1.default.createElement(react_intl_1.FormattedMessage, { key: 'dateError', id: 'components/Form/Field/Date:tooPastDate', defaultMessage: 'Date cannot be earlier than {date}', values: {
                    date: pastError,
                } }))];
    }
    const futureDates = [
        disableFutureDays ? tomorrow : undefined,
        disabledAfterDay,
        notAllowedAfterDate,
    ];
    const futureError = (_b = getError(futureDates, false, (x) => date.isSameOrAfter(x, 'day'))) === null || _b === void 0 ? void 0 : _b.format(dateTimeFormat_1.DATE_FORMAT);
    if (futureError) {
        return [(react_1.default.createElement(react_intl_1.FormattedMessage, { key: 'dateError', id: 'components/Form/Field/Date:tooFutureDate', defaultMessage: 'Date cannot be later than {date}', values: {
                    date: futureError,
                } }))];
    }
    return undefined;
};
exports.validateDate = validateDate;
const validateTime = (rawDateTime, restrictions, canCast) => {
    var _a, _b;
    if (!rawDateTime.time)
        return undefined;
    const timeText = canCast ? (0, format_1.standardizeInputTime)(rawDateTime.time) : rawDateTime.time;
    const isValid = (0, exports.checkFormat)(timeText, dateTimeFormat_1.TIME_FORMAT);
    if (!isValid) {
        return [(react_1.default.createElement(react_intl_1.FormattedMessage, { key: 'dateError', id: 'components/Form/Field/Date:invalidTimeFormat', defaultMessage: 'The time must be in the format {timeFormat}', values: {
                    timeFormat: dateTimeFormat_1.TIME_FORMAT,
                } }))];
    }
    const dateError = (0, exports.validateDate)(rawDateTime.date, restrictions, canCast);
    if (dateError)
        return undefined;
    const dateTime = (0, format_1.parseInputDateTime)(rawDateTime);
    if (!dateTime)
        return undefined;
    const { notAllowedBeforeDate, notAllowedAfterDate, } = restrictions || {};
    const pastDates = [
        notAllowedBeforeDate,
    ];
    const pastError = (_a = getError(pastDates, true, (x) => (dateTime.isBefore(x, 'minute') && dateTime.isSame(x, 'day')))) === null || _a === void 0 ? void 0 : _a.format(dateTimeFormat_1.TIME_FORMAT);
    if (pastError) {
        return [(react_1.default.createElement(react_intl_1.FormattedMessage, { key: 'dateError', id: 'components/Form/Field/Date:tooPastTime', defaultMessage: 'Time cannot be earlier than {time}', values: {
                    time: pastError,
                } }))];
    }
    const futureDates = [
        notAllowedAfterDate,
    ];
    const futureError = (_b = getError(futureDates, true, (x) => (dateTime.isSameOrAfter(x, 'minute') && dateTime.isSame(x, 'day')))) === null || _b === void 0 ? void 0 : _b.format(dateTimeFormat_1.TIME_FORMAT);
    if (futureError) {
        return [(react_1.default.createElement(react_intl_1.FormattedMessage, { key: 'dateError', id: 'components/Form/Field/Date:tooFutureTime', defaultMessage: 'Time cannot be later than {time}', values: {
                    time: futureError,
                } }))];
    }
    return undefined;
};
exports.validateTime = validateTime;
const validateDateTime = (dateTime, restrictions, withTime, canCast) => ({
    date: (0, exports.validateDate)(dateTime.date, restrictions, canCast),
    time: withTime ? (0, exports.validateTime)(dateTime, restrictions, canCast) : undefined,
});
exports.validateDateTime = validateDateTime;
const validateDateRange = (value, restrictions, canCast) => {
    const defaultResult = {
        from: (0, exports.validateDate)(value.from, restrictions, canCast),
        to: (0, exports.validateDate)(value.to, restrictions, canCast),
    };
    if (defaultResult.from || defaultResult.to)
        return defaultResult;
    const from = (0, moment_1.default)(value.from, dateTimeFormat_1.DATE_FORMAT);
    const to = (0, moment_1.default)(value.to, dateTimeFormat_1.DATE_FORMAT);
    if (to.isBefore(from, 'day')) {
        return {
            to: [(react_1.default.createElement(react_intl_1.FormattedMessage, { key: 'dateError', id: 'components/Form/Field/Date:toBeforeFrom', defaultMessage: 'Date "to" cannot be earlier than date "from"' }))],
        };
    }
    return {};
};
exports.validateDateRange = validateDateRange;
//# sourceMappingURL=validation.js.map